import React from "react";

const ProjectEmpty = () => {
  return <li className="project--empty"></li>;
};

export default ProjectEmpty;
